import { CSSProperties, PropsWithChildren } from 'react';

import { cn } from '@cineamo/ui/src/helpers/cn';

export default function CardWrapper({
    className,
    children,
    style
}: PropsWithChildren<{ className?: string; style?: CSSProperties }>) {
    return (
        <div
            className={cn('bg-[var(--hero-background-color)]', className)}
            style={style}>
            {children}
        </div>
    );
}
